import React, { useState, useEffect } from 'react'
import { useDocuments } from 'contexts/documents'
import { sendAppSignal } from 'hooks/app-signal'
import BottomPanel from 'panels/bottom'
import Content from './content'
import Modal from 'modals/dialog'
import BulkEditDocuments from 'pages/documents/modals/bulk-document'

export const fullSelectionActions = ['download']

const BulkPanel = ({ salt }) => {
    const {
        selection,

        getEditableSelection,
        deselectAllDocuments
    } = useDocuments()

    const [showing, setShowing] = useState(false)
    const [editing, setEditing] = useState(null)
    const [progress, setProgress] = useState(defaultProgress)

    const onProgress = result => setProgress(progress => ({
        ...progress,
        [result]: progress[result] + 1,
        processed: progress.processed + 1
    }))

    const resetProgress = () => setProgress(defaultProgress)

    const toggle = show => {
        resetProgress()

        if(showing === show) {
            return
        }

        setShowing(show)
        sendAppSignal('bottom-panel.toggle', show)

        if(!show && !!selection.length) {
            deselectAllDocuments()
        }
    }

    useEffect(() => {
        toggle(!!selection.length)
    }, [showing, selection.length])

    if(!selection) {
        return null
    }

    return (
        <>
            <BottomPanel
                show={!!showing}
                dismiss={() => toggle(false)}>
                <Content
                    act={field => {
                        setProgress({
                            ...defaultProgress,
                            which: field,
                            total: fullSelectionActions.includes(field) ?
                                selection.length :
                                getEditableSelection().length
                        })

                        setEditing(field)
                    }}
                    progress={progress}
                    resetProgress={resetProgress}
                    dismiss={() => toggle(false)}
                    salt={salt} />
            </BottomPanel>
            <Modal
                show={!!editing}
                dismiss={() => {
                    setEditing(null)
                    resetProgress()
                }}
                className="scrollable">
                <BulkEditDocuments
                    which={editing}
                    progress={progress}
                    setProgress={setProgress}
                    onProgress={onProgress}
                    onDone={() => setEditing(null)}
                    salt={salt} />
            </Modal>
        </>
    )
}

const defaultProgress = {
    which: null,
    busy: false,
    settled: false,
    skipped: 0,
    succeeded: 0,
    failed: 0,
    processed: 0,
    total: 0
}

export default BulkPanel